<template>
  <mu-container>
    <mu-flex class="flex-wrapper" justify-content="center">
      <mu-flex class="m-8" fill>
        <mu-paper :z-depth="1" class="w-100 p-20">
          <mu-form ref="form" @submit.prevent="handleSubmit" :model="address">
            <mu-row>
              <mu-col span="5">
                <mu-form-item
                  label="Imię *"
                  help-text="Imię klienta"
                  prop="firstname"
                  :rules="firstNameRules"
                >
                  <mu-text-field
                    type="text"
                    name="firstname"
                    v-model="address.firstname"
                    tabindex="1"
                  ></mu-text-field>
                </mu-form-item>
              </mu-col>
              <mu-col offset="2" span="5">
                <mu-form-item
                  label="Adres *"
                  help-text="Adres klienta z numerem domu i mieszkania"
                  prop="street"
                  :rules="streetRules"
                >
                  <mu-text-field
                    type="text"
                    name="street"
                    v-model="address.street"
                    tabindex="4"
                  ></mu-text-field>
                </mu-form-item>
              </mu-col>
            </mu-row>
            <mu-row>
              <mu-col span="5">
                <mu-form-item
                  label="Nazwisko *"
                  help-text="Nazwisko klienta"
                  prop="lastname"
                  :rules="lastNameRules"
                >
                  <mu-text-field
                    type="text"
                    name="lastname"
                    v-model="address.lastname"
                    tabindex="2"
                  ></mu-text-field>
                </mu-form-item>
              </mu-col>
              <mu-col offset="2" span="5">
                <mu-form-item
                  label="Kod pocztowy *"
                  help-text="Kod pocztowy klienta"
                  prop="postcode"
                  :rules="postcodeRules"
                >
                  <mu-text-field
                    type="text"
                    name="postcode"
                    v-model="address.postcode"
                    tabindex="5"
                  ></mu-text-field>
                </mu-form-item>
              </mu-col>
            </mu-row>
            <mu-row>
              <mu-col span="5">
                <mu-form-item
                  label="Numer telefonu *"
                  help-text="Numer telefonu klienta"
                  prop="phone"
                  :rules="phoneRules"
                >
                  <mu-text-field
                    type="text"
                    name="phone"
                    v-model="address.phone"
                    tabindex="3"
                  ></mu-text-field>
                </mu-form-item>
              </mu-col>
              <mu-col offset="2" span="5">
                <mu-form-item
                  label="Miasto *"
                  help-text="Miasto klienta"
                  prop="city"
                  :rules="cityRules"
                >
                  <mu-text-field
                    type="text"
                    name="city"
                    v-model="address.city"
                    tabindex="6"
                  ></mu-text-field>
                </mu-form-item>
              </mu-col>
            </mu-row>
            <mu-row>
              <mu-col span="5">
                <mu-form-item
                  label="Email"
                  help-text="Email klienta"
                  prop="email"
                  :rules="emailRules"
                >
                  <mu-text-field
                    type="text"
                    name="email"
                    v-model="address.email"
                    tabindex="3"
                  ></mu-text-field>
                </mu-form-item>
              </mu-col>
            </mu-row>
            <mu-row>
              <mu-col span="12">
                <small>
                  Email klienta, który jest wykorzystywany jedynie w celu
                  wysłania informacji o aktualnym stanie zamówienia.
                </small>
                <p>Pola oznaczone * są obowiązkowe.</p>
              </mu-col>
            </mu-row>
          </mu-form>
        </mu-paper>
      </mu-flex>
    </mu-flex>
    <mu-flex class="flex-wrapper" justify-content="center">
      <mu-flex class="m-8" fill>
        <mu-paper :z-depth="1" class="w-100 p-20">
          <mu-row>
            <div v-if="cart.length > 0">
              <mu-data-table
                stripe
                :columns="columns"
                :data="cart"
                :sort.sync="sort"
              >
                <template slot-scope="scope">
                  <td>{{ scope.row.name }}</td>
                  <td>
                    <mu-text-field
                      class="w-25 mt-10"
                      v-model="scope.row.quantity"
                      @change="handleChange(scope.row)"
                    >
                    </mu-text-field>
                  </td>
                  <td>
                    {{
                      Number(scope.row.quantity * scope.row.price).toFixed(2)
                    }}
                  </td>
                  <td>
                    {{
                      Number(scope.row.quantity * scope.row.suggested).toFixed(
                        2
                      )
                    }}
                  </td>
                  <td>
                    {{
                      Number(
                        scope.row.quantity *
                          (scope.row.suggested - scope.row.price)
                      ).toFixed(2)
                    }}
                  </td>
                  <td class="is-left">
                    <mu-button
                      icon
                      color="red"
                      @click="handleDelete(scope.row)"
                    >
                      <mu-icon value="delete"></mu-icon>
                    </mu-button>
                  </td>
                </template>
              </mu-data-table>
              <p>
                Cena całkowita:
                <strong>{{ Number(cartAmounts.price).toFixed(2) }} zł</strong>
              </p>
              <p>
                Twój zysk:
                <strong
                  >{{ Number(cartAmounts.earnings).toFixed(2) }} zł</strong
                >
              </p>
            </div>
            <h3 v-else>Koszyk jest pusty...</h3>
          </mu-row>
          <mu-row class="mt-50">
            <mu-select
              label="Dodaj produkt..."
              placeholder="Wybierz produkt..."
              full-width
              filterable
              @change="handleSelect"
            >
              <mu-option
                v-for="product in productsData"
                :key="product.name"
                :label="`${product.name} - ${product.price} PLN`"
                :value="product"
              ></mu-option>
            </mu-select>
          </mu-row>
        </mu-paper>
      </mu-flex>
    </mu-flex>
    <mu-flex class="flex-wrapper" justify-content="center">
      <mu-flex justify-content="center" class="m-8" fill>
        <mu-paper :z-depth="1" class="w-100 p-20">
          <h3>Wybierz sposób dostawy:</h3>
          <div class="select-control-group">
            <mu-flex
              class="select-control-row"
              :key="carrier.id"
              v-for="carrier in carriers"
            >
              <mu-radio
                :value="carrier.id"
                v-model="address.idCarrier"
                :label="`${carrier.name} - ${carrier.price}zł`"
              ></mu-radio>
            </mu-flex>
          </div>
          <br />
          <mu-button full-width @click="handleSubmit">
            <mu-icon left value="shopping_basket"></mu-icon>
            złóż zamówienie
          </mu-button>
        </mu-paper>
      </mu-flex>
    </mu-flex>
  </mu-container>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "AddOrderPage",
  data() {
    return {
      address: {
        firstname: "",
        lastname: "",
        street: "",
        postcode: "",
        city: "",
        phone: "",
        email: "",
        idCarrier: 60
      },
      columns: [
        { title: "Produkt", width: "300", name: "name" },
        { title: "Ilość", width: "80" },
        { title: "Twoja Cena", width: "150" },
        { title: "Cena Detaliczna", width: "150" },
        { title: "Twój Zysk", width: "150" },
        { title: "Akcje", width: "120" }
      ],
      cart: [],
      sort: {
        name: "",
        order: "asc"
      },
      submitted: false,
      firstNameRules: [
        { validate: val => !!val, message: "Imię nie może byc puste!" },
        {
          validate: val => val.length >= 3,
          message: "Imię musi miec przynajmniej 3 znaki"
        }
      ],
      lastNameRules: [
        { validate: val => !!val, message: "Nazwisko nie może być puste!" },
        {
          validate: val => val.length >= 3,
          message: "Nazwisko musi miec przynajmniej 3 znaki"
        }
      ],
      streetRules: [
        { validate: val => !!val, message: "Adres nie może być pusty!" },
        {
          validate: val => val.length >= 8,
          message: "Adres musi miec przynajmniej 8 znakow"
        },
        {
          validate: val => val.length <= 32,
          message: "Adres musi miec maksymalnie 32 znaki"
        },
        {
          validate: val => this.hasNumber(val),
          message: "Adres musi miec numer domu"
        }
      ],
      postcodeRules: [
        { validate: val => !!val, message: "Kod pocztowy nie może być pusty!" },
        {
          validate: val => val.length !== 5,
          message: "Kod pocztowy musi miec 6 znakow! Format: XX-XXX"
        },
        {
          validate: val => val.indexOf("-") > 0,
          message: "Poprawny format: 00-000!"
        }
      ],
      cityRules: [
        { validate: val => !!val, message: "Miasto nie może być puste!" },
        {
          validate: val => val.length >= 3,
          message: "Miasto musi miec przynajmniej 3 znaki"
        }
      ],
      phoneRules: [
        {
          validate: val => !!val,
          message: "Numer telefonu nie może być pusty!"
        },
        {
          validate: val => val.length !== 8,
          message: "Numer telefonu musi miec 9 znakow!"
        }
      ],
      emailRules: [
        {
          validate: val => this.validEmail(val),
          message: "Podano niepoprawny email"
        }
      ]
    };
  },
  computed: {
    ...mapState("user", ["productsData"]),
    ...mapState("shipping", ["carriers"]),
    cartAmounts() {
      if (this.cart.length > 0) {
        return this.cart.reduce(
          (acc, item) => ({
            price: acc.price + item.quantity * item.price,
            earnings:
              acc.earnings + item.quantity * (item.suggested - item.price)
          }),
          {
            price: 0,
            earnings: 0
          }
        );
      }
      return {
        price: 0,
        earnings: 0
      };
    }
  },
  methods: {
    ...mapActions("order", ["placeOrder"]),
    handleSelect(v) {
      if (!this.cart.find(item => item.id === v.id)) {
        this.cart.push({
          ...v,
          quantity: 1
        });
      }
    },
    handleChange(v) {
      if (v.quantity < 0) v.quantity = Math.abs(v.quantity);
    },
    handleDelete(v) {
      this.cart = this.cart.filter(item => item.id !== v.id);
    },
    handleSubmit() {
      this.submitted = true;
      this.$refs.form.validate().then(valid => {
        if (valid && this.cart.length > 0) {
          this.placeOrder({
            address: this.address,
            cart: this.cart
          });
        }
      });
    },
    hasNumber(myString) {
      return /\d/.test(myString);
    },
    validEmail(email) {
      //eslint-disable-next-line
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3})|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (email.length > 0) {
        return re.test(email);
      }
      return true;
    }
  }
};
</script>
